// extracted by mini-css-extract-plugin
export var base = "_5c-0";
export var updateBanner = "_5c-1";